import { forwardRef } from 'react';
import { SusyButtonIconProps } from './SusyButtonDefinitions';

const SusyButtonIcon = forwardRef(
    (
        {
            icon,
            onClickHandler,
            classes,
            dataTestId,
            htmlAttributes,
        }: SusyButtonIconProps,
        ref: React.Ref<HTMLButtonElement>
    ) => {
        return (
            <button
                ref={ref}
                type='button'
                className={`susy-button susy-button-icon ${classes ?? ''}`}
                onClick={onClickHandler}
                data-testid={dataTestId}
                {...htmlAttributes}
            >
                {icon}
            </button>
        );
    }
);

SusyButtonIcon.displayName = 'SusyButtonIcon';

export default SusyButtonIcon;
